import React, { createContext, useContext, useState } from "react";
import { Flavor, Platform } from "../../docs/loader";

export type DocsFiltersContextValue = {
  selectedPlatforms: Platform[];
  setSelectedPlatforms: (p: Platform[]) => void;
  selectedFlavors: Flavor[];
  setSelectedFlavors: (f: Flavor[]) => void;
};

const DocsFiltersContext = createContext<DocsFiltersContextValue | undefined>(
  undefined
);

export const useDocsFilters = (): DocsFiltersContextValue => {
  const ctx = useContext(DocsFiltersContext);
  if (!ctx)
    throw new Error("useDocsFilters must be used within DocsFiltersProvider");
  return ctx;
};

export const DocsFiltersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedPlatforms, setSelectedPlatforms] = useState<Platform[]>([]);
  const [selectedFlavors, setSelectedFlavors] = useState<Flavor[]>([]);

  return (
    <DocsFiltersContext.Provider
      value={{
        selectedPlatforms,
        setSelectedPlatforms,
        selectedFlavors,
        setSelectedFlavors,
      }}
    >
      {children}
    </DocsFiltersContext.Provider>
  );
};
